import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=7dda0c7c&"
import script from "./ActivityDetail.vue?vue&type=script&lang=js&"
export * from "./ActivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ActivityDetail.vue"
export default component.exports